import {TEST_IDS} from './testIds';

const isRentalCarTravelerEligible = ({age}) => age >= 24;

export const RIDER_DISPLAY = {
  luggage: {formikKey: 'isCharger', icon: 'suitcase', price: '0.4', testId: TEST_IDS.rider('luggage'), titleId: 'riders.luggage'},
  extremeSport: {formikKey: 'isEsports', icon: 'mountain', price: '0.7', testId: TEST_IDS.rider('extremeSport'), titleId: 'riders.extreme'},
  winterSport: {formikKey: 'isWsports', icon: 'snow', price: '7.5', testId: TEST_IDS.rider('winterSport'), titleId: 'riders.winterExtreme'},
  cancellation: {formikKey: 'isTravelsc', icon: 'calendarX', price: '1', testId: TEST_IDS.rider('cancellation'), titleId: 'riders.cancellationShort'},
  pc: {formikKey: 'isPccover', icon: 'laptop', price: '1.25', testId: TEST_IDS.rider('pc'), titleId: 'riders.pcAndTabletSpaced'},
  mobile: {formikKey: 'isMobilecover', icon: 'mobile', price: '1.25', testId: TEST_IDS.rider('mobile'), titleId: 'riders.mobile'},
  rentalCar: {
    formikKey: 'isCancellationOfSelfParticipationOnRentedCar',
    icon: 'car',
    price: '7',
    testId: TEST_IDS.rider('rentalCar'),
    titleId: 'riders.cancellationOfSelfParticipationOnRentedCarTrimmed',
    isTravelerEligible: isRentalCarTravelerEligible,
    isEligible: travelers => travelers.some(isRentalCarTravelerEligible),
  },
};